// extracted by css-extract-rspack-plugin
export default {"parameterItem":"mEHca","buttonLink":"DyJ3K"};